module.exports = __webpack_public_path__ + "img/ic_add.664dad5c.svg";